import React from 'react';
import './QuotationDetails.css'

const QuotationDetails = ({ quotationInfo, setQuotationInfo }) => {
  return (
    <div className="QuotationForm__quotation-details-section">
      <div className="QuotationForm__quotation-fields-row">
        <div className="QuotationForm__field-group">
          <label htmlFor="quotationNumber" className="QuotationForm__label">
            Quotation Number *
          </label>
          <input
            id="quotationNumber"
            type="text"
            className="QuotationForm__input"
            placeholder="Enter quotation number"
            value={quotationInfo.number}
            required
            onChange={e => setQuotationInfo({ ...quotationInfo, number: e.target.value })}
          />
        </div>
        <div className="QuotationForm__field-group">
          <label htmlFor="issueDate" className="QuotationForm__label">
            Issue Date
          </label>
          <input
            id="issueDate"
            type="date"
            className="QuotationForm__input"
            value={quotationInfo.issueDate}
            onChange={e => setQuotationInfo({ ...quotationInfo, issueDate: e.target.value })}
          />
        </div>
      </div>
    </div>
  );
};

export default QuotationDetails;
